<template>
  <div>
    <div class="homepage-title">
      <h1 v-html="title"></h1>
    </div>
    <div class="content">
      <div class="col" v-html="content"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SimplePage',

  data () {
    return {
    }
  },

  props: {
    title: {
      type: String,
      required: false,
      default: ''
    },
    content: {
      type: String,
      required: false,
      default: 'Content goes here'
    }
  }
}
</script>

<style scoped>
.homepage-title {
  position: relative;
  margin-top: -60px;
  z-index: 5;
  display: block;
  padding-left: 35px;
  height: 70px;
  max-width: 40%;
  word-wrap: wrap;
}

.content {
  column-count: 1;
  padding: 20px;
}

.content .col {
  padding-bottom: 20px;
}

/* Small devices (landscape phones, 576px and up) */
@media (max-width: 576px) {
}

/* Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) {
}

/* Medium devices (tablets, 768px and up) The navbar toggle appears at this breakpoint */
@media (min-width: 768px) {
  .homepage-title {
    max-width: unset;
  }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) {
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
}
</style>
